var map = {
	"./CanvasClear": 371,
	"./CanvasClear.ts": 371,
	"./CanvasMove": 6301,
	"./CanvasMove.ts": 6301,
	"./CommandAbstract": 5301,
	"./CommandAbstract.ts": 5301,
	"./ComponentDelete": 8542,
	"./ComponentDelete.ts": 8542,
	"./ComponentDrag": 1319,
	"./ComponentDrag.ts": 1319,
	"./ComponentEnter": 1859,
	"./ComponentEnter.ts": 1859,
	"./ComponentExit": 3709,
	"./ComponentExit.ts": 3709,
	"./ComponentNext": 2860,
	"./ComponentNext.ts": 2860,
	"./ComponentPrev": 4944,
	"./ComponentPrev.ts": 4944,
	"./ComponentStyleClear": 767,
	"./ComponentStyleClear.ts": 767,
	"./CopyComponent": 2126,
	"./CopyComponent.ts": 2126,
	"./ExportTemplate": 4860,
	"./ExportTemplate.ts": 4860,
	"./Fullscreen": 1085,
	"./Fullscreen.ts": 1085,
	"./MoveComponent": 9622,
	"./MoveComponent.ts": 9622,
	"./OpenAssets": 8481,
	"./OpenAssets.ts": 8481,
	"./OpenBlocks": 3666,
	"./OpenBlocks.ts": 3666,
	"./OpenLayers": 5838,
	"./OpenLayers.ts": 5838,
	"./OpenStyleManager": 8692,
	"./OpenStyleManager.ts": 8692,
	"./OpenTraitManager": 9163,
	"./OpenTraitManager.ts": 9163,
	"./PasteComponent": 9298,
	"./PasteComponent.ts": 9298,
	"./Preview": 8594,
	"./Preview.ts": 8594,
	"./Resize": 7604,
	"./Resize.ts": 7604,
	"./SelectComponent": 4596,
	"./SelectComponent.ts": 4596,
	"./SelectPosition": 2983,
	"./SelectPosition.ts": 2983,
	"./ShowOffset": 9490,
	"./ShowOffset.ts": 9490,
	"./SwitchVisibility": 1396,
	"./SwitchVisibility.ts": 1396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;